import baseAPI from "@/http";

const router = "api/MunicipioAd";
const routerAnexo = "api/MunicipioAdAnexos";

export const municipioAdsApi = {
  add: (agentes) => baseAPI.post(`${router}`, agentes),
  edit: (agentes) => baseAPI.put(`${router}`, agentes),
  delete: (agenteId) => baseAPI.delete(`${router}?id=${agenteId}`),
  getAgentesByCodigoIBGE: (codigoIbge) =>
    baseAPI.post(`${router}/get-municipio-by-codigo-ibge`, codigoIbge),
  gerarXls: (codigoIBGE) =>
    baseAPI.get(`${router}/gerar-xlsx-municipio-ad`, { responseType: "blob" }),
  downloadAnexo: (anexoId) =>
    baseAPI.post(
      `${router}/download-anexo-ad?municipioPropostaAnexosId=${anexoId}`,
      null,
      {
        responseType: "blob",
      }
    ),
};

export const municipioAdsAnexoApi = {
  add: (agentes) => baseAPI.post(`${routerAnexo}`, agentes),
  edit: (agentes) => baseAPI.put(`${routerAnexo}`, agentes),
  delete: (agenteId) => baseAPI.delete(`${routerAnexo}?id=${agenteId}`),
};
